import AutoComplete from './src/autocomplete';

module.exports = AutoComplete;


// WEBPACK FOOTER //
// ./src/components/autocomplete/index.js